import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesEnum } from './configuration/enums/routes.enum';
import { domainFastCheckoutGuard } from './guards/domain-fast-checkout.guard';
import { domainLoggedAreaGuard } from './guards/domain-logged-area.guard';
import { featureFlagGuard } from './guards/feature-flag.guard';
import { paymentLinkInitGuard } from './guards/payment-link-init.guard';

export const routes: Routes = [
  {
    path: RoutesEnum.LOGGED_AREA,
    canMatch: [featureFlagGuard('logged-area')],
    loadChildren: async () =>
      (await import('./features/logged-area/logged-area.module')).LoggedAreaModule,
    canActivate: [domainLoggedAreaGuard],
  },
  {
    path: RoutesEnum.FAST_CHECKOUT,
    canMatch: [featureFlagGuard('fast-checkout')],
    loadChildren: async () =>
      (await import('./features/fast-checkout/fast-checkout.module')).FastCheckoutModule,
    canActivate: [domainFastCheckoutGuard],
  },
  {
    path: RoutesEnum.PASSWORD_LESS,
    loadChildren: async () =>
      (await import('./features/password-less/password-less.module')).PasswordLessModule,
  },
  {
    path: RoutesEnum.ENROLLMENT,
    loadChildren: async () =>
      (await import('./features/enrollment/enrollment.routes')).enrollmentRoutes,
  },
  {
    path: '',
    canMatch: [paymentLinkInitGuard],
    loadChildren: async () =>
      (await import('./features/payment-link/payment-link.module')).PaymentLinkModule,
  },
  {
    path: '',
    loadChildren: async () => (await import('./pages/pages.routes')).PAGES_ROUTES,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
